// From the official published Voiceflow installation snippet (Ask Dr. Verdant v1.00).
export const VOICEFLOW = {
  projectID: "6ae22e549338cc97fa66ddec",
  url: "https://general-runtime.voiceflow.com",
  versionID: "",
  bundleSrc: "https://cdn.voiceflow.com/widget-next/bundle.mjs",
  voiceUrl: "https://runtime-api.voiceflow.com",
};
